import { render } from "./StudentReviewView.vue?vue&type=template&id=371e64e8&scoped=true"
import script from "./StudentReviewView.vue?vue&type=script&lang=js"
export * from "./StudentReviewView.vue?vue&type=script&lang=js"

import "./StudentReviewView.vue?vue&type=style&index=0&id=371e64e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371e64e8"]])

export default __exports__